(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name languageDiscrepancy.controller:LanguageDiscrepancyCtrl
   *
   * @description
   *
   */
  angular
    .module('languageDiscrepancy')
    .controller('LanguageDiscrepancyCtrl', LanguageDiscrepancyCtrl);

  function LanguageDiscrepancyCtrl(CommonMasterData, languageDiscrepancyService, MessageService) {
    var vm = this;
    vm.ctrlName = 'LanguageDiscrepancyCtrl';

    vm.model = {
      searchPanelToggle: true,
      totalNumberOfRecords:null,
      width: window.screen.width,
      height:window.screen.height,
      searchCriteria: {
        fromDate: null,
        toDate: null,
        language: null,
        mandatoryLanguageOption: null,
        distributionGroupsList: null,
        condition: false
      },
      masterList: {
        languageList: [],
        mandatoryLanguageOptionsList: [
          {mandatoryLanguageOptionDesc: "Yes", mandatoryLanguageOptionCode: "Y"},
          {mandatoryLanguageOptionDesc: "No", mandatoryLanguageOptionCode: "N"}
        ],
        distributionGroups: [],
        fromDateFormatInvalid: false,
        toDateFormatInvalid: false,
        fromDateAfterToDate: false,
        languageDiscrepancyList: []
      },
      initialSearchDone: false
    };
    var dataObject = [];
    var hotSettings = [];
    var hot;

    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    vm.submitSearch = function (params) {
      languageDiscrepancyService.searchLanguageDiscrepancy(vm.model.searchCriteria, function (response) {
        vm.model.searchPanelToggle = false;
        vm.model.languageDiscrepancyList = response.languageDiscrepancyDTOList;
        vm.model.totalNumberOfRecords = response.languageDiscrepancyDTOList.length;

        dataObject = vm.dataObject();
        hotSettings = vm.hotSettings();
        hot = new Handsontable(hotElement, hotSettings);
      },
        function (error) {
          MessageService.error(error[0]);
        })
    };

    vm.dataObject = function () {
      var dataObject = [];

      for (var i in vm.model.languageDiscrepancyList) {
        dataObject.push({
          ROW_NUMBER : parseInt(i)+1,
          PATTERN_NAME: vm.model.languageDiscrepancyList[i].patternName,
          CREW_ASSIGED: vm.model.languageDiscrepancyList[i].crewAssigned,
          CREW_REQUIRED: vm.model.languageDiscrepancyList[i].crewRequired,
          STARTD_DATE_TIME: vm.model.languageDiscrepancyList[i].startDate,
          AIRCRAFT_MODEL_NUMBER: vm.model.languageDiscrepancyList[i].airCraftModelNum,
          LANGUAGE: vm.model.languageDiscrepancyList[i].language

        })
      }
      return dataObject;
    };

    vm.hotSettings = function () {
      var hotSettings = {
        data: dataObject,
        undo: true,
        redo: true,
        copy: true,
        paste: true,
        copyRowsLimit: 1000000,

        columns: [
          {
            data: 'ROW_NUMBER',
            type: 'numeric',
            readOnly: true,
            manualColumnResize:13

          },
          {
            data: 'PATTERN_NAME',
            type: 'text',
            readOnly: true
          },
          {
            data: 'STARTD_DATE_TIME',
            type: 'text',
            readOnly: true
          },
          {
            data: 'LANGUAGE',
            type: 'text',
            readOnly: true
          }, {
            data: 'CREW_REQUIRED',
            type: 'text',
            readOnly: true
          }, {
            data: 'CREW_ASSIGED',
            type: 'text',
            readOnly: true
          }, {
            data: 'AIRCRAFT_MODEL_NUMBER',
            type: 'text',
            readOnly: true
          }],

        stretchH: 'all',
        width: vm.model.width * 0.99,
        autoWrapRow: true,
        height: vm.model.height * 0.6,
        rowHeaders: true,
        colHeaders: [
          '',
          'Pairing Name',
          'Start Date Time',
          'Language',
          'Crew Required',
          'Crew Assigned',
          'A/C Type'

        ]
      };

      return hotSettings;
    };

    var hotElement = document.querySelector('#hot');

    vm.changeSearchField = function (searchParams, flag) {
      setDateValidationFlags();
      var tempFromDate = moment(searchParams.fromDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
      if (tempFromDate != undefined && tempFromDate.toUpperCase() != "INVALID DATE" && flag != "toDate" ) {
        searchParams.toDate = tempFromDate;
      }
      if (!vm.model.masterList.toDateFormatInvalid
        && !vm.model.masterList.fromDateFormatInvalid) {
        if (istoDateBeforeFromDate()) {
          vm.model.masterList.fromDateAfterToDate = true;
        } else {
          vm.model.masterList.fromDateAfterToDate = false;
        }
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
      }
    };

    function setDateValidationFlags() {
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }

      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
      }
    }

    function isDateFormatInvalid(date) {
      return (!!date && !moment(date, "DD/MM/YYYY").isValid());
    }

    function istoDateBeforeFromDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isBefore(
          moment(vm.model.searchCriteria.fromDate,
            "DD/MM/YYYY"));
    };

    (function () {
      CommonMasterData.getLanguageList(function (languageList) {
        vm.model.masterList.languageList = languageList;
      }, function (error) {
        console.log('language List retrieval error!');
      });

    })();

    (function () {
      languageDiscrepancyService.searchActiveDistributionConfigIdentifiers(function (response) {
        const activeDistributionIdentifierList = response.activeDistributionIdentifierList;
        const distributionGroups = [];
        angular.forEach(activeDistributionIdentifierList, function(activeDistributionIdentifier) {
          var distributionGroup = {
            distributionGroupDescription: activeDistributionIdentifier,
            distributionGroupCode: activeDistributionIdentifier
          };
          distributionGroups.push(distributionGroup);
        });
        vm.model.masterList.distributionGroups = distributionGroups;
      }, function (error) {
        console.log('Active Distribution Config Identifiers List retrieval error!', error.msg[0]);
      });
    })();
  }

}());
